import { memo, useMemo } from "react";
import {
  StyledSummaryBarCellUserAvatar,
  StyledSummaryBarCellUserValueElement,
} from "./Detail.styles";

const getInitialsFromFullName = (fullName = "") => {
  const parts = fullName.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "--";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
};

/**
 * SummaryBarCellUserValue
 *
 * Displays a user name with a circular initials avatar, aligned for summary bars.
 */
const SummaryBarCellUserValue = memo(({ fullName }) => {
  const initials = useMemo(() => getInitialsFromFullName(fullName), [fullName]);

  if (!fullName) {
    return <StyledSummaryBarCellUserValueElement>--</StyledSummaryBarCellUserValueElement>;
  }

  return (
    <StyledSummaryBarCellUserValueElement title={fullName}>
      <StyledSummaryBarCellUserAvatar aria-hidden="true">{initials}</StyledSummaryBarCellUserAvatar>
      <span>{fullName}</span>
    </StyledSummaryBarCellUserValueElement>
  );
});

export { SummaryBarCellUserValue, getInitialsFromFullName };
